
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/compare-agents",
      function () {
        return require("private-next-pages/agents/compare-agents.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/compare-agents"])
      });
    }
  